export class TipoTributacaoServicoISSQN {
    tipo: string;
    descricao: string;

    constructor(tipo?: string, descricao?: string) {
        this.tipo = tipo;
        this.descricao = descricao;
    }

    public Listar(): TipoTributacaoServicoISSQN[] {
        return [
            new TipoTributacaoServicoISSQN("N", "NORMAL"),
            new TipoTributacaoServicoISSQN("R", "RETIDA"),
            new TipoTributacaoServicoISSQN("S", "SUBSTITUTA"),
            new TipoTributacaoServicoISSQN("I", "ISENTA")
        ];
    }

}